import Box from './box/Box';
import { Spinner } from './Spinner';
import * as React from 'react';

export const LoadingFallback = () => (
  <Box flex='1' height='100vh' alignItems='center' justifyContent='center'>
    <Spinner />
  </Box>
);
